import MaintenancePage from "../MaintenancePage";
import resource from "../../resources/employeePayClassResource";

export default function EmployeePayClass() {
    return <MaintenancePage resource={resource} />;
}
